import React from 'react';
import cx from 'classnames';
import '../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../../common/GradientWrapper/index.js';
import { Icon } from '../../../../common/Icon/index.js';
import '../../../../common/LazyImage/index.js';
import '../../../../common/NumberFormat/index.js';
import { WithCustomScrollbar } from '../../../../common/WithCustomScrollbar/index.js';
import '../../../../cards/AuthPromo/index.js';
import { Card } from '../../../../cards/Card/index.js';
import '../../../../cards/CategoryCard/index.js';
import '../../../../cards/CryptoFeature/index.js';
import '../../../../cards/GamePreview/index.js';
import '../../../../cards/Promo/PromoCardSimple/index.js';
import '../../../../cards/Promo/PromotionCard/index.js';
import '../../../../cards/Provider/index.js';
import '../../../../cards/SportsBook/index.js';
import '../../../../cards/SecurityCard/index.js';
import '../../../../cards/WinCard/index.js';
import { Link } from 'react-router-dom';
import styles from '../Modal/index.module.scss.js';

const UserInfoGameList = ({
  title = "Favorite Games",
  games,
  text = {
    emptyMsg: /* @__PURE__ */ React.createElement(React.Fragment, null, "The list is currently empty \u2014 but you can change that by playing in the", " ", /* @__PURE__ */ React.createElement(Link, { to: "/casino" }, "casino"))
  },
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles["list-wrapper"], className, {
      [styles.margin]: games.length >= 5
    }),
    style
  },
  /* @__PURE__ */ React.createElement("div", { className: cx(styles["list-title"]) }, /* @__PURE__ */ React.createElement(Icon, { iconName: "VerifiedIcon" }), title),
  /* @__PURE__ */ React.createElement(WithCustomScrollbar, { className: cx(styles["horizontal-scroll"]) }, games.length ? /* @__PURE__ */ React.createElement("div", { className: cx(styles.list) }, games.map((item, i) => /* @__PURE__ */ React.createElement("div", { className: cx(styles["game-item"]), key: `${item.id} + ${i}` }, /* @__PURE__ */ React.createElement(
    Card,
    {
      ...item,
      index: item.id,
      key: `${item.id} + ${i}`,
      type: "GAME_V2"
    }
  )))) : /* @__PURE__ */ React.createElement("div", { className: cx(styles["empty-block"]) }, /* @__PURE__ */ React.createElement("div", null, text.emptyMsg)))
);
UserInfoGameList.displayName = "UserInfoModal.UserInfoGameList";

export { UserInfoGameList };
//# sourceMappingURL=index.js.map
